import React, { useEffect, useState } from "react";
import Main from "../components/admin/Main";
import PageContainer from "../components/admin/PageContainer";
import Modal from "../components/admin/Modal";
import CollapseCard from "../components/admin/CollapseCard";
import VendorForm from "../components/admin/VendorForm";
import VendorList from "../components/admin/VendorList";
import { createVendor, deleteVendor, fetchVendor, updateVendor } from "../service/VendorService";
import { useToast } from "../components/toast/ToastProvider";

const VendorPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [vendorData, setVendorData] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [formData, setFormData] = useState({
         name: "",
         address1: "",
         address2: "",
         address3: "",
         address4: "",
         contactNumbers: "",
         status: "",
         createdBy: "admin",
       });
   const handleClear = () => {
        setFormData({
          name: "",
          address1: "",
          address2: "",
          address3: "",
          address4: "",
          contactNumbers: "",
          status: "",
          createdBy: "admin",
        });
      }

  const toast = useToast();

  const fetchdData = async () => {
     const res = await fetchVendor();
     setVendorData(res);     
    //  toast("Fetched Successfully", "SUCCESS");

  };

  useEffect(() => {
    fetchdData();
  }, []);

    useEffect(() => {
      if (selectedVendor) {
        setFormData(selectedVendor);
      } 
    }, [selectedVendor]);
  
     const handleChange = (e) => {
       const { name, value } = e.target;
       setFormData((pre) => ({ ...pre, [name]: value }));
  };
  
   const handleEdit = (data) => {
     setSelectedVendor(data);
     setShowModal(true);
   };

  const handleSubmit = async (e) => {
     e.preventDefault();
    try {
     
      if (selectedVendor) {
        await updateVendor(selectedVendor.id, formData);
        toast("Vendor Updated Successfully", "SUCCESS");
      } else {
         const { status, ...payload } = formData;  // 👈 remove status
      await createVendor(payload);     
        toast("Vendor Created Successfully", "SUCCESS");
      }
      const res = await fetchVendor();
      setVendorData(res);
      setShowModal(false);
      handleClear()
      setSelectedVendor(null);
    } catch (error) {
      toast("Error in save vendor","ERROR")
    }
  }
 const handleDelete = async(id) => {
    if (window.confirm("Are you sure you want to delete this ad?")) {
      await deleteVendor(id);
      toast("Vendor Deleted Successfully", "SUCCESS");
      const res = await fetchVendor();
      setVendorData(res);
    }
  };

  return (
    <Main>
      <PageContainer
        title="Vendor Page"
        buttonText={"ADD"}
        onButtonClick={() => {
          setShowModal(true);
          setSelectedVendor(null);
        }}
      >
        {/* Add and Edit Form Modal */}
        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            handleClear();
            setShowModal(false);
            setSelectedVendor(null);
          }}
          headerText={selectedVendor ? "Edit vendor" : "Add Vendor"}
          centered
        >
          <VendorForm
            handleChange={handleChange}
            handleClear={handleClear}
            formData={formData}
            handleSubmit={handleSubmit}
            selectedVendor={selectedVendor}
            
          />
        </Modal>

        <CollapseCard title="Vendor List">
          <VendorList
            vendorData={vendorData}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default VendorPage;
